export default __webpack_public_path__ + "static/media/EG_Zoom-3.5524f23d.wav";